import { MimaButton, Modal, MimaText } from '../../components';
import styles from '../../assets/styles/Employees/Employees.module.scss';
import successImg from '../../assets/img/Successful.png';
import React from 'react';
import { userStore } from '../../stores';

const TerminateBulkEmployees = ({ closeModal, uploaded, uploadClick, selectClick, loading, file, setShowSurvey,	needFeedback, }) => {
	return (
		<Modal closeModal={closeModal} goBack={closeModal}>
			<MimaText variant="subtitle" mb={3}>
				Terminate Bulk Employees
			</MimaText>
			{!uploaded && (
				<>
					<MimaText
						variant="small"
						mb={2}
						width={38}
						align="center"
						color="var(--color-primary)"
					>
						To terminate your Employees in bulk kindly click the button below
						and download our excel template.
					</MimaText>

					<a href="https://res.cloudinary.com/mima-business/raw/upload/v1665743535/Employee-Bulk-Terminate-Template_enursr.csv" target="_blank">
						<MimaButton
							title="Download Template"
							variant="colorable"
							buttonColor="var(--color-dark)"
							mb={5}
						/>
					</a>

					<MimaButton
						title="Select file"
						variant="outlined"
						width={38}
						onClick={selectClick}
					/>
					<MimaText
						variant="small"
						mt={2}
						width={38}
						align="center"
						color="var(--color-primary)">{file?.name || ''} </MimaText>

					<MimaButton
						title="Upload Employee Info"
						onClick={uploadClick}
						mt={2}
						loading={loading}
					/>
				</>
			)}
			{uploaded && (
				<>
					<img
						src={successImg}
						alt="Upload success"
						className={styles.success}
					/>
					<MimaText
						variant="h3"
						width={38}
						align="center"
						color="var(--color-success)"
						mb={2}
					>
						Upload <br />
						Successful
					</MimaText>
					{/* <MimaText width={38} align="center" color="var(--color-primary)">
						You successfully Terminated 25 employees
					</MimaText> */}
					<MimaButton title="Continue" onClick={() => {
						closeModal();
						if (needFeedback._id) {
							setShowSurvey(true)
							userStore.setReviewId(needFeedback._id)
						}
						return;
					}} mt={3} />
				</>
			)}
		</Modal>
	);
};

export default TerminateBulkEmployees;
